import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = () => {
  return (
    <>
      <Navbar expand className="pt-0">
        <Container fluid>
          <Navbar.Brand> The X-Man </Navbar.Brand>
          <Navbar.Text
            className="icons mx-auto"
            style={{ fontSize: "3rem", color: "black" }}
          >
            <a
              href={"https://github.com/Damithedev"}
              target="_blank"
              rel="noreferrer"
            >
              <i className="icons fa-brands fa-github me-2"></i>
            </a>
            <a
              href={"https://www.linkedin.com/in/damilola-tirimisiu-03971026a"}
              target="_blank"
              rel="noreferrer"
            >
              <i className="icons fa-brands fa-linkedin"></i>
            </a>
          </Navbar.Text>
          <Nav justify={"center"}></Nav>
          <Nav.Item>
            <Nav.Link active>Home</Nav.Link>
          </Nav.Item>
        </Container>
      </Navbar>
    </>
  );
};
export default Header;
